import { ArrowUpRight } from "lucide-react";
import { Chapter, Reveal } from "@/components/Reveal";

const AREAS = [
  { n: "01", t: "EFFICIENZA PERSONALE", d: "Aiutare l'imprenditore e le persone chiave a recuperare focus, produttività e capacità di gestione.", span: "md:col-span-7" },
  { n: "02", t: "RISORSE UMANE", d: "Selezione, inserimento, sviluppo, responsabilizzazione e gestione delle persone.", span: "md:col-span-5" },
  { n: "03", t: "ORGANIZZAZIONE", d: "Ruoli, responsabilità, organigrammi, mansionari, procedure e delega.", span: "md:col-span-4" },
  { n: "04", t: "GESTIONE FINANZIARIA", d: "Comprendere i numeri dell'azienda e utilizzarli per prendere decisioni migliori.", span: "md:col-span-4" },
  { n: "05", t: "VENDITE", d: "Processi commerciali, gestione dei lead, performance e sviluppo delle capacità di vendita.", span: "md:col-span-4" },
  { n: "06", t: "MARKETING STRATEGICO", d: "Posizionamento, strategia, acquisizione e fidelizzazione.", span: "md:col-span-6" },
  { n: "07", t: "INTELLIGENZA ARTIFICIALE", d: "Applicazioni concrete dell'IA per migliorare processi, marketing e produttività aziendale.", span: "md:col-span-6" },
];

const Areas = () => (
  <section id="consulenza" data-testid="areas-section" className="bg-fog py-28 text-ink lg:py-40">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
      <Chapter index="03" label="Aree di intervento" />
      <Reveal>
        <h2 className="font-display text-4xl font-extrabold tracking-tighter sm:text-5xl lg:text-6xl">
          L'azienda a 360°.
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-5 md:grid-cols-12 lg:mt-24">
        {AREAS.map((a, i) => (
          <Reveal key={a.n} delay={(i % 3) * 0.08} className={a.span}>
            <article
              data-testid={`area-card-${a.n}`}
              className="gold-glow-hover group flex h-full flex-col justify-between border border-ink/10 bg-white p-8 transition-colors duration-500 hover:border-accent lg:p-10"
            >
              <div className="flex items-start justify-between">
                <span className="font-mono text-[11px] tracking-[0.3em] text-accent-dark">{a.n}</span>
                <ArrowUpRight className="h-4 w-4 text-ink/20 transition-all duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-accent-dark" aria-hidden="true" />
              </div>
              <div className="mt-14">
                <h3 className="font-display text-xl font-bold tracking-tight lg:text-2xl">{a.t}</h3>
                <p className="mt-4 max-w-md text-sm leading-relaxed text-ink/55">{a.d}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Areas;
